//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    discountFlag: {
      type: Boolean,
      default: false
    },
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {};
  },
  created: function created() {},
  mounted: function mounted() {},
  computed: {},
  methods: {
    closePop: function closePop() {
      this.$emit("update:discountFlag", false);
    }
  },
  components: {},
  watch: {},
  beforeDestroy: function beforeDestroy() {}
};